"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONMANAGER = exports.TASKMANAGER = exports.ACTIONSTATEMANAGER = exports.FLOWMANAGER = exports.PROJECTMANAGER = exports.CONNECTIONS = exports.ICONFINDER = exports.HELP = exports.TOOLS_OPTIONS = exports.TOOLS = exports.RUN = exports.VIEW = exports.EDIT = exports.FILE = void 0;
exports.FILE = 'FILE';
exports.EDIT = 'EDIT';
exports.VIEW = 'VIEW';
exports.RUN = 'RUN';
exports.TOOLS = 'TOOLS';
exports.TOOLS_OPTIONS = 'TOOLS.OPTIONS';
exports.HELP = 'HELP';
exports.ICONFINDER = 'ICONFINDER';
exports.CONNECTIONS = 'CONNECTIONS';
exports.PROJECTMANAGER = 'PROJECTMANAGER';
exports.FLOWMANAGER = 'FLOWMANAGER';
exports.ACTIONSTATEMANAGER = 'ACTIONSTATEMANAGER';
exports.TASKMANAGER = 'TASKMANAGER';
exports.PERMISSIONMANAGER = 'PERMISSIONMANAGER';
//# sourceMappingURL=DefaultMenubarItems.js.map